import React from "react";

const INPUT_CLASSES =
  "w-full bg-transparent border-2 border-current px-4 py-3 font-body text-lg outline-none focus:bg-[hsl(var(--primary))] focus:text-[hsl(var(--primary-foreground))] focus:border-[hsl(var(--primary))]";

// Explicit attributes only — no prop spreading onto DOM elements.
export default function Field({
  label,
  multiline = false,
  testId,
  type = "text",
  rows,
  value,
  onChange,
  placeholder,
  required,
}) {
  return (
    <label className="block">
      <span className="eyebrow block mb-2">{label}</span>
      {multiline ? (
        <textarea
          className={INPUT_CLASSES + " resize-none"}
          rows={rows}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          required={required}
          data-testid={testId}
        />
      ) : (
        <input
          className={INPUT_CLASSES}
          type={type}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          required={required}
          data-testid={testId}
        />
      )}
    </label>
  );
}
